import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import {useSnackbar} from 'notistack';
import {useReplaceProvinceMutation, useGetCountriesQuery} from 'api';
import ProvinceForm from './ProvinceForm';

function ProvinceEditIconButton({province}) {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [replaceProvince] = useReplaceProvinceMutation();
  const {data} = useGetCountriesQuery();

  const formRef = React.useRef();
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const {enqueueSnackbar} = useSnackbar();

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const handleOpen = () => {
    setIsModalOpen(true);
  };
  return (
    <>
      <Dialog fullWidth maxWidth="sm" open={isModalOpen}>
        <DialogTitle>Update Province</DialogTitle>
        <DialogContent dividers>
          <ProvinceForm
            initialValues={{
              _id: province._id,
              name: province.name,
              countryId: province.countryId,
            }}
            countriesList={data || []}
            ref={formRef}
            onSubmit={async (values, actions) => {
              setIsSubmitting(true);
              try {
                const newObj = {
                  ...values,
                };
                await replaceProvince(newObj).unwrap();
                actions.resetForm();
                enqueueSnackbar('Province updated successfully', {
                  variant: 'success',
                });
                setIsModalOpen(false);
              } catch (e) {
                const message =
                  e.status === 400 ? e.provinceResponse?.details?.[0]?.message : undefined;
                enqueueSnackbar(message || 'Failed to update Province', {
                  variant: 'error',
                });
              } finally {
                setIsSubmitting(false);
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button color="inherit" disabled={isSubmitting} autoFocus onClick={handleClose}>
            Cancel
          </Button>
          <Button
            disabled={isSubmitting}
            color="success"
            endIcon={isSubmitting ? <CircularProgress size={16} /> : null}
            onClick={() => formRef.current?.submit?.()}
          >
            update
          </Button>
        </DialogActions>
      </Dialog>
      <IconButton disabled={isSubmitting} onClick={handleOpen} aria-label="edit" color="primary">
        <EditIcon />
      </IconButton>
    </>
  );
}

export default ProvinceEditIconButton;
